import { useCallback, useEffect, useMemo, useState } from 'react';
import UITextToolbarSelect from 'rich-text-lib/components/editor/UITextToolbarSelect';
import { getActiveMark, setMarkCommand } from '../utils/markUtils';
import { FONT_SIZES } from '../constants/fontConstants';
import useDebouncedEditorStateContext from '../contexts/useDebouncedEditorStateContext';
import I18n from 'I18n';
import { parseAvailableFontSize } from '../utils/fontUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const setFontSize = attrs => setMarkCommand(schema => schema.marks.font_size, attrs);
const sizes = FONT_SIZES.map(size => {
  return {
    text: `${size.points}`,
    value: `${size.points}pt`
  };
});
const getAvailableFontSize = fontSize => fontSize && parseAvailableFontSize(fontSize) || FONT_SIZES[0].points;
export default function FontSizeMark({
  defaultFontSize
}) {
  const {
    editorState,
    setEditorState
  } = useDebouncedEditorStateContext();
  const defaultAvailableSize = useMemo(() => {
    return getAvailableFontSize(defaultFontSize);
  }, [defaultFontSize]);
  const [sizeValue, setSizeValue] = useState(defaultAvailableSize);
  useEffect(() => {
    const activeFontSize = getActiveMark(editorState, editorState.schema.marks.font_size);
    if (activeFontSize) {
      setSizeValue(activeFontSize.attrs.size);
    } else {
      setSizeValue(defaultAvailableSize);
    }
  }, [editorState, setSizeValue, defaultAvailableSize]);
  const applyFontSize = useCallback(evt => {
    setFontSize({
      size: evt.target.value
    })(editorState, tr => {
      const newTr = tr.setMeta('font_size', evt.target.value);
      setEditorState(editorState.apply(newTr));
    });
    setSizeValue(evt.target.value);
  }, [editorState, setEditorState, setSizeValue]);
  return /*#__PURE__*/_jsx(UITextToolbarSelect, {
    "data-test-id": "size-styles-dropdown",
    className: "size-styles-dropdown"
    // @ts-expect-error not in types
    ,
    onChange: applyFontSize,
    options: sizes,
    value: sizeValue,
    placeholder: I18n.text('hubspot-prosemirror.buttons.fontSizePlaceholder')
  });
}